import styled from 'styled-components';
import { Text } from '@terrainvest/react-components';

export const StyledDisclaimerText = styled(Text)`
    ${props => `color: ${props.theme.global.colors.doveGrayLight};`}
    text-align: justify;
`;
